// Global JIATF-401 navigation-menu visibility setting.
// Controls whether the top-level "JIATF-401" dropdown (counter-small-UAS Deployment Plans + Dynamic
// Engagement) is shown in the main nav. Stored in localStorage so it persists
// across sessions without a backend migration (mirrors ibcsNavSetting.js).
// Toggled from Platform Management; the nav reacts live via the custom event.

export const JIATF_NAV_KEY = 'jiatf_nav_enabled';

// Fired on window whenever the setting changes so the nav can update live
// without a reload.
export const JIATF_NAV_EVENT = 'jiatf-nav-changed';

// Default OFF — the JIATF-401 hub stays hidden until an operator explicitly enables
// it from Platform Management, keeping the default menu focused on TMPC.
export function isJiatfNavEnabled() {
  const v = localStorage.getItem(JIATF_NAV_KEY);
  return v === null ? false : v === 'true';
}

export function setJiatfNavEnabled(enabled) {
  localStorage.setItem(JIATF_NAV_KEY, enabled ? 'true' : 'false');
  // Notify the nav in this tab; cross-tab syncing rides the native 'storage' event.
  window.dispatchEvent(new CustomEvent(JIATF_NAV_EVENT, { detail: { enabled } }));
}
